type Primitive = number | string | boolean | bigint | symbol | null | undefined;

/**
 * Adds all truthy elements (and 0) of an array into a string, separated by the specified separator string.
 * @param elements The elements to concatenate.
 * @param separator A string used to separate one element of the array from the next in the resulting string. If omitted, the array elements are separated with a comma.
 */
export const joinTruthies = (
  elements: Primitive[],
  separator = ',',
): string => {
  return elements.reduce<string>((acc, element) => {
    if (element || element === 0) {
      return acc
        ? `${acc}${separator}${element.toString()}`
        : element.toString();
    }
    return acc;
  }, '');
};
